<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Lesson Plan</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_ay" item-value="ay_id"
                        :items="academic_year_list" item-text="academicyear" label="Select Academic Year" outlined
                        @click="show = false" persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="user_type == 'Parent'">
                    <v-combobox color="#0f2027" rounded v-model="selected_children" :items="children"
                        label="Select Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle"
                        @click="show = false"></v-combobox>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn class="button" :loading="fetch_loader" @click="getDetails()">Proceed</v-btn>
                </v-col>
            </v-row>
            <v-data-table v-if="coff_learner_list != ''" dense :headers="headers" class="mytable elevation-1"
                :items="coff_learner_list">
                <template v-slot:item.action="{ item }">
                    <v-btn small @click="getLessonplanTrack(item.coff_id)" class="button">Proceed</v-btn>
                </template>
            </v-data-table>
            <!-- {{crs_plan_execution_list}} -->
            <v-dialog v-model="dialog" max-width="1500px">
                <v-card>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong> Lesson Plan Tracking </strong>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn fab small color="white" outlined icon @click="dialog = false"><v-icon> mdi-close
                            </v-icon></v-btn>
                    </v-toolbar>
                    <v-card class="box">
                        <v-simple-table dense class="mytable elevation-1">
                            <thead>
                                <tr>
                                    <td>Sr No.</td>
                                    <td>Date</td>
                                    <td>Chapter</td>
                                    <td>Concept/Skill/Topic Covered</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in crs_plan_execution_list" :key="item.id">
                                    <td>{{ item.srno }}</td>
                                    <td>{{ item.execution_date }}</td>
                                    <td>{{ item.chapter }}</td>
                                    <td>{{ item.topic }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>
                    <center>
                        <v-btn class="button" @click="dialog = false">Cancel</v-btn>
                    </center>
                </v-card>
            </v-dialog>
        </v-card>
         <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">View Lesson Plan Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/jp9PLcgFT68?si=DiRpz3oI16h-eNQj"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
    import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                snackbar_msg: "",
                color: "",
                snackbar: false,
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                loader: true,
                children: [],
                academic_year_list: [],
                selected_children: null,
                videoDialog:false,
                selected_ay: null,
                fetch_loader: false,
                coff_learner_list: [],
                crs_plan_execution_list: [],
                headers: [
                    { text: "Sr.No.", value: "srno" },
                    { text: "Course", value: "coff" },
                    { text: "Lesson Track", value: "action" },
                ],
                user_type: null,
                dialog: false,
                uid: null,
            };
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getLessonplanTrack(coff_id) {
                var registration_number;
                if (this.user_type == "Parent") {
                    registration_number = this.selected_children.registration_number;
                }
                if (this.user_type == "Student") {
                    registration_number = this.uid;
                }
                const data = {
                    user_type: this.user_type,
                    registration_no: registration_number,
                    ay: this.selected_ay,
                    coff_id: coff_id,
                };
                axios
                    .post("/LessonPlanExecution/getLessonplanTrack", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_plan_execution_list = res.data.crs_plan_execution_list;
                            this.dialog = true;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getDetails() {
                var registration_number;
                if (this.user_type == "Parent") {
                    registration_number = this.selected_children.registration_number;
                }
                if (this.user_type == "Student") {
                    //  alert(this.uid)
                    registration_number = this.uid;
                }
                const data = {
                    user_type: this.user_type,
                    registration_no: registration_number,
                    ay: this.selected_ay,
                };
                this.fetch_loader = true;
                axios
                    .post("/LessonPlanExecution/getLessonPlanTrackingParentStud", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.coff_learner_list = res.data.coff_learner_list;
                            this.fetch_loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.fetch_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                    });
            },
        },
        mounted() {
            this.user_type = localStorage.getItem("EPS-ut");
            if (this.user_type == "Student") {
                this.uid = localStorage.getItem("EPS-uid");
            }
            //alert(this.user_type)
            let org_id = localStorage.getItem("EPS-tenant");
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status = "SUCCESS")) {
                            this.children = res.data.learners;
                            this.academic_year_list = res.data.academic_year_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something Went Wrong");
                        }
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong");
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                    //alert("done")
                });
        },
    };
</script>
<style>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        text-align: center;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
            text-align: center;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
            text-align: center;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
</style>
